import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
    theme: {
        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        step: {
            width: '136px',
            maxWidth: '136px',
            fontFamily: BrandTokens.FontFamily
        },
        line: {
            active: {
                backgroundColor: BrandTokens.BrandColorPrimaryPure
            },
            disabled: {
                backgroundColor: BrandTokens.NeutralColorLowMedium
            }
        },
        indicator: {
            width: '24px',
            height: '24px',
            finished: {
                width: '24px',
                height: '24px',
                borderRadius: GlobalTokens.BorderRadiusCircular,
                backgroundColor: BrandTokens.BrandColorPrimaryPure,
                color: BrandTokens.NeutralColorHighPure,
                border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.BrandColorPrimaryPure}`
            },
            current: {
                width: '24px',
                height: '24px',
                borderRadius: GlobalTokens.BorderRadiusCircular,
                fontSize: GlobalTokens.FontSizeXxs,
                fontWeight: BrandTokens.FontWeightMedium,
                lineHeight: GlobalTokens.LineHeightDefault,
                backgroundColor: BrandTokens.NeutralColorHighPure,
                color: BrandTokens.BrandColorPrimaryPure,
                border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.BrandColorPrimaryPure}`
            },
            disabled: {
                width: '8px',
                height: '8px',
                borderRadius: GlobalTokens.BorderRadiusCircular,
                backgroundColor: BrandTokens.NeutralColorLowMedium,
            },
            animation: {
                shadowWidth: GlobalTokens.BorderWidthThick,
                shadowColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelIntense)
            }
        },
        label: {
            fontWeight: BrandTokens.FontWeightMedium,
            fontSize: GlobalTokens.FontSizeXxs,
            color: BrandTokens.BrandColorPrimaryPure,
            lineHeight: GlobalTokens.LineHeightDefault,
            padding: `${GlobalTokens.SpacingSizeXxxs} ${GlobalTokens.SpacingSizeNano} 0`,
            disabled: {
                color: BrandTokens.NeutralColorLowMedium
            }
        },
        progress: {
            height: '4px',
            marginBottom: GlobalTokens.SpacingSizeNano,
            borderTop: '1px',
            borderTopColor: BrandTokens.BrandColorPrimaryLight,
            borderTopStyle: 'solid',
            bar: {
                backgroundColor: BrandTokens.BrandColorPrimaryLight
            },
            value: {
                borderRadius: `0 ${GlobalTokens.BorderRadiusPill} ${GlobalTokens.BorderRadiusPill} 0`,
                backgroundColor: BrandTokens.BrandColorPrimaryPure
            }
        },
        caption: {
            padding: `${GlobalTokens.SpacingSizeXs} 0 ${GlobalTokens.SpacingSizeXs} ${GlobalTokens.SpacingSizeXxs}`,
            color: BrandTokens.NeutralColorLowMedium,
            fontSize: GlobalTokens.FontSizeXxs,
            fontWeight: BrandTokens.FontWeightRegular,
            fontFamily: BrandTokens.FontFamily
        }
    }
}